import { grey } from '@material-ui/core/colors';

export const itemBackground = grey['200'];
export const subText = grey['600'];
